export default __webpack_public_path__ + "static/media/nomadN.03e8beef.png";